<template>
    <div v-bind="$attrs" class="tiptap-display break-word">
        {{ editor?.getText().substring(0, 250).trim()
        }}{{ editor?.getText().length > 250 ? "..." : "" }}
    </div>
</template>

<script setup>
import { useEditor, EditorContent } from "@tiptap/vue-3";
import StarterKit from "@tiptap/starter-kit";
import { Placeholder } from "@tiptap/extension-placeholder";
import TiptapMenuButton from "./tiptap/tiptap-menu-button.vue";
import { Link } from "@tiptap/extension-link";
import { nextTick, onMounted, reactive, ref } from "vue";
import { Mention } from "@tiptap/extension-mention";
import { mentionSuggestion } from "./tiptap/suggestion";
import SimpleLoadingCircle from "../SimpleLoadingCircle.vue";

const props = defineProps({
    post: Object,
});

function parseContent(text) {
    const asJson = JSON.parse(text);
    const content = asJson?.content?.map((node) => {
        const content =  node?.content?.map((item) => {
            if (item.text?.startsWith("https://") || item.text?.startsWith("http://")) {
                return { ...item, text: " " }
            }
            return item
        })
        node.content = content
        return node
    })
    asJson.content = content
    return asJson
}

const editor = useEditor({
    editable: false,
    extensions: [
        StarterKit,
        Placeholder.configure({
            placeholder: "",
        }),
        Link.configure({
            openOnClick: true,
            HTMLAttributes: {
                class: "text-blue-500 hover:underline",
            },
        }),
        Mention.configure({
            suggestion: mentionSuggestion,
            HTMLAttributes: {
                class: "font-semibold mx-2 text-blue-800 bg-blue-100 rounded-md px-2 py-1",
            },
            renderLabel: (props) => {
                return `@${props.node.attrs.id.name}`;
            },
        }),
    ],
    editorProps: {
        attributes: {
            class: "outline-none",
        },
    },
    content: parseContent(props.post.content),
});
</script>

<style>
.tiptap-display .ProseMirror p.is-editor-empty:first-child::before {
    content: attr(data-placeholder);
    float: left;
    color: #adb5bd;
    pointer-events: none;
    height: 0;
}

.tiptap-display .ProseMirror code {
    background: #d0dae0;
    color: #1e4964;
    padding: 4px 6px;
    border-radius: 4px;
    font-size: 0.75em;
    font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier,
        monospace;
}
</style>
